import PropTypes from "prop-types";
import React from "react";

import { Card, Icon, Section, Text } from "@swa-ui/core";
import { swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";

import { ConfirmationNumber } from "../ConfirmationNumber";
import styles from "./FlightConfirmationCard.module.scss";

/** FlightConfirmationCard displays the departure to arrival city, date, and confirmation number. */

export const FlightConfirmationCard = (props) => {
  const { cities, confirmationNumber, departureDate } = props;

  return (
    <Card>
      <Section headingProps={getHeadingProps()}>
        <div className={styles.dateAndConfirmationLine}>
          <Text size="xlarge">{swaDate(departureDate).format("MMM D")}</Text>
          <Icon {...getIconProps()} />
          <ConfirmationNumber {...getConfirmationNumberProps()} />
        </div>
      </Section>
    </Card>
  );

  function getHeadingProps() {
    return {
      children: i18n("FlightConfirmationCard__DESTINATIONS_HEADER", cities),
      className: styles.titleLine,
      styleLevel: 5,
    };
  }

  function getIconProps() {
    return {
      className: styles.bulletIcon,
      color: "flight-confirmation-card-confirmation-label",
      name: "Bullet",
      size: "10",
    };
  }

  function getConfirmationNumberProps() {
    return {
      ariaLabel: i18n("FlightConfirmationCard__CONFIRMATION_NUMBER_ARIA_LABEL"),
      bold: false,
      label: i18n("FlightConfirmationCard__CONFIRMATION_NUMBER_LABEL"),
      labelClassName: styles.confirmationLabel,
      labelColor: "flight-confirmation-card-confirmation-label",
      number: confirmationNumber,
      numberClassName: styles.confirmationNumber,
      showLabelColon: false,
      size: "medium",
    };
  }
};

FlightConfirmationCard.propTypes = {
  /** Cities in the trip. */
  cities: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,

  /** Confirmation number. */
  confirmationNumber: PropTypes.string.isRequired,

  /** Departure date, ISO format. */
  departureDate: PropTypes.string.isRequired,
};
